import { Theme } from "../../const/preAuthConsts";
import { promptZoomForNewScreenSize } from "../../utils/infra/screenResolution/promptZoomForNewScreenSize";
import { formatPreAuthServerError } from "../../utils/preAuthUtils";
import { trackLoginFailure, trackLoginSuccess } from "../../utils/tracking";
import type Api from "../../api/Api";
import ApiInstance from "../../api/ApiInstance";
import { dismissToasts } from "../../components/app/Notifications/notifications";
import { setConnectedLoadingContextElement } from "../../components/common/LoadingContainer/ConnectedLoadingContainer";
import { invokeApiMethod } from "../invokeApiMethod";
import * as preAuthActionTypes from "./preAuthActionTypes";

export function loginUser({
    username = undefined,
    password = undefined,
    emailMfaCode = undefined,
    trustThisComputer = false,
    duoMfaResponse = undefined,
} = {}) {
    return function (dispatch, getState, { api }: { api: Api }) {
        return api
            .loginUser({
                username,
                password,
                emailMfaCode,
                trustThisComputer,
                duoMfaResponse,
            })
            .then(response => {
                const isSSO = !username;
                if (!isSSO) {
                    trackLoginSuccess(
                        username,
                        response.password_days_left,
                        response.requires_mfa,
                        !!(emailMfaCode || duoMfaResponse),
                        false,
                    );
                    onUserLoginSuccess();
                }
                return Promise.resolve(response);
            })
            .catch(error => {
                trackLoginFailure(username, formatPreAuthServerError(error), !!emailMfaCode);
                return Promise.reject(error);
            });
    };
}

export const onSSOLoginSuccess = (passwordDaysLeft: number, username: string) => {
    onUserLoginSuccess();
    trackLoginSuccess(username, passwordDaysLeft, false, false, true);
};

const onUserLoginSuccess = () => {
    dismissToasts();
    promptZoomForNewScreenSize();
};

const restoreLoginSuccess = ({ user_details }) => ({
    type: preAuthActionTypes.SET_USERNAME,
    username: user_details.username,
});
// TODO: get username from somewhere else and use isLoggedIn for checking initial login state
export const restoreLogin = () => invokeApiMethod("restoreLogin", [], restoreLoginSuccess, undefined, true);

// Theme Actions
export const setDarkMode =
    (isDarkMode: boolean, store = false) =>
    dispatch => {
        const theme = isDarkMode ? Theme.DARK : Theme.LIGHT;
        dispatch({
            type: preAuthActionTypes.SET_DARK_MODE,
            theme: theme,
        });
        if (store) return ApiInstance.api.updateUserPreferences({ theme });
    };

// UI actions
const setLoading = (currentlyLoading: boolean | string, contextElement: HTMLElement) => {
    setConnectedLoadingContextElement(contextElement);
    return { type: preAuthActionTypes.CURRENTLY_LOADING, currentlyLoading };
};
export const startLoading = setLoading;
export const endLoading = () => setLoading(undefined, undefined);
